/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useMemo, useCallback, Fragment } from "react";

import Iframe from "react-iframe";

// eslint-disable-next-line node/no-missing-import
import type * as CSS from "csstype";

// My Components:
import DivE from "../react/DivE.tsx";
// Redux-hooks:
import { useAppSelector, useAppDispatch } from "../../libs/redux-hooks.ts";
// Reducers:
import { getAppState, getUser } from "../../libs/reducer.ts"; // getTheme, getLng, getDict, changeAppState
// My functions
import fnc from "../../libs/fnc.ts";
// Types:
import type {TuniversalElementProps} from "../../types/Iuigen.d.ts";
import type {Tpermissions} from "../../types/easyTypes.ts";

const { rz } = window;

const RZiframe:FC<TuniversalElementProps> = ({attributes, children}) => {
  RZiframe.displayName = "iframe";
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUser);
  // const theme = useAppSelector(getTheme);
  // const lng = useAppSelector(getLng);
  // const dct = useAppSelector(getDict);
  // const rlng = (lng === "en" ? "ru" : "en");

  const {rootAttributes, key, fullPath} = attributes;
  const appState = useAppSelector(getAppState(rootAttributes.key)), elState = appState[fullPath];
  // const rootNamespace = useMemo(() => (window[rootAttributes?.key || rz.strMakeID(24)]), [rootAttributes?.key]);

  const permissions = useMemo<Tpermissions>(() => (fnc.checkPermissions(user, attributes)), [user, attributes]);

  const clsu = useMemo<Array<string>>(() => {
    const userClss = rz.objClone(elState?.userClass || []);
    if ((elState?.disabled || permissions.disabled === true) && !~userClss.indexOf("uk-disabled")) { userClss.push("uk-disabled") }
    return userClss;
  }, [elState?.userClass, elState?.disabled, permissions]);

  const styl = useMemo<CSS.Properties>(() => {
    const est = {...elState.userStyle};
    if ((elState?.visible === false || permissions.visible === false) && est.display !== "none") { est.display = "none" }
    else if ((elState?.visible === true && permissions.visible !== false) && est.display === "none") { est.display = undefined }
    return est;
  }, [elState?.userStyle, elState?.visible, permissions]);

  return (
    <Iframe id={key} className={clsu.join(" ")} styles={styl}
      url={elState.value || attributes.src || ""}
      width={elState.attributes.width || attributes.width || "100%"} height={elState.attributes.height || attributes.height || "100%"}
      position={(elState.attributes.position || attributes.position ? elState.attributes.position || attributes.position : undefined)}
      scrolling={(attributes.scrolling ? attributes.scrolling : undefined)}
      frameBorder={(attributes.frameBorder || attributes.frameborder ? attributes.frameBorder || attributes.frameborder : undefined)}
      overflow={(attributes.overflow ? attributes.overflow : undefined)}
      allowFullScreen={(attributes.allowFullScreen || attributes.allowfullscreen ? attributes.allowFullScreen || attributes.allowfullscreen : undefined)}
      sandbox={(attributes.sandbox ? rz.arrGetUnique(attributes.sandbox.split(" "), true, true, true) : undefined)}
      allow={(attributes.allow ? attributes.allow : undefined)}
    />
  );
}

export default RZiframe;
/* eslint-enable @typescript-eslint/no-unused-vars */
